// Uniswap V3/V4 tick <-> price conversion, DISPLAY ONLY - never fed back into a transaction, so
// plain floating point (not the fixed-point PriceLib/TickMath math the contracts themselves use)
// is fine here.

/// Price of token1 per token0 at a given tick, decimal-adjusted.
export function tickToPrice(tick, decimals0 = 18, decimals1 = 18) {
  return Math.pow(1.0001, Number(tick)) * Math.pow(10, decimals0 - decimals1)
}

/// Inverse of tickToPrice - used to place an amounts-ratio-derived approximate price (V4's
/// current-price marker, see RangeVisualization's own doc comment) on the same tick-linear axis
/// the real range bars are drawn on, without needing a real pool tick read.
export function priceToTick(price, decimals0 = 18, decimals1 = 18) {
  if (!(price > 0)) return null
  const raw = price / Math.pow(10, decimals0 - decimals1)
  return Math.log(raw) / Math.log(1.0001)
}
